import { Component, OnInit, ViewEncapsulation, ViewChild, Output, EventEmitter } from '@angular/core';
import { QuibblService } from '../../quibbl.service';

@Component({
  selector: 'channel-panel',
  templateUrl: './channel-panel.component.html',
  styleUrls: ['./channel-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChannelPanelComponent implements OnInit {

  @ViewChild('politicsBlock') private politicsBlock;
  @ViewChild('entertainmentBlock') private entertainmentBlock;
  @ViewChild('sportsBlock') private sportsBlock;

  @Output() categoryChange: EventEmitter<any> = new EventEmitter();
  @Output() calloutChange: EventEmitter<any> = new EventEmitter();

  public politicsChildren = [];
  public entertainmentChildren = [];
  public sportsChildren = [];

  public childrenSubscription;

  public currentCategory;

  constructor(private _qb: QuibblService) { }

  ngOnInit() {
  }

  public politicsHandler() {
    if(this.politicsBlock.expanded) {
      this.entertainmentBlock.expanded = false;
      this.sportsBlock.expanded = false;

      if(this.childrenSubscription) this.childrenSubscription.unsubscribe();
      this.childrenSubscription =
        this._qb.getChannelChildren('politics').subscribe(children => {
          this.politicsChildren = children;
          this.categoryChange.emit("politics");
          this.currentCategory = "politics";
        });
    }

    else {
      this.categoryChange.emit(null);
      this.currentCategory = null;
    }
  }

  public entertainmentHandler() {
    if(this.entertainmentBlock.expanded) {
      this.politicsBlock.expanded = false;
      this.sportsBlock.expanded = false;

      if(this.childrenSubscription) this.childrenSubscription.unsubscribe();
      this.childrenSubscription =
        this._qb.getChannelChildren('entertainment').subscribe(children => {
          this.entertainmentChildren = children;
          this.categoryChange.emit("entertainment");
          this.currentCategory = "entertainment";
        });
    }

    else {
      this.categoryChange.emit(null);
      this.currentCategory = null;
    }
  }

  public sportsHandler() {
    if(this.sportsBlock.expanded) {
      this.entertainmentBlock.expanded = false;
      this.politicsBlock.expanded = false;

      if(this.childrenSubscription) this.childrenSubscription.unsubscribe();
      this.childrenSubscription =
        this._qb.getChannelChildren('sports').subscribe(children => {
          this.sportsChildren = children;
          this.categoryChange.emit("sports");
          this.currentCategory = "sports";
        });
    }

    else {
      this.categoryChange.emit(null);
      this.currentCategory = null;
    }
  }

  public handleClick(event, enabled) {
    if(!enabled) {
      return;
    }
    
    if(event == "Overall") {
      this.entertainmentBlock.expanded = false;
      this.politicsBlock.expanded = false;
      this.sportsBlock.expanded = false;
      this.categoryChange.emit(null);
      this.currentCategory = null;
    }

    else {
      this.calloutChange.emit(event);
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/leaderboard/channel-panel/channel-panel.component.ts